import { useRef } from "react";
import { toast, Flip } from "react-toastify";
import api from "../../../../features/auth/axiosConfig";

interface UseImportReturn {
  inputRef: React.RefObject<HTMLInputElement>;
  handleImport: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

interface UseImportProps {
  setLoading: (value: boolean) => void;
}

const useImport = ({ setLoading }: UseImportProps): UseImportReturn => {
  const inputRef = useRef<HTMLInputElement>(null);
  const handleImport = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;
    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);
    api
      .post("/app/v2/import_export", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(() => {
        toast.success("CSV imported successfully", {
          position: "top-right",
          autoClose: 2000,
          theme: "colored",
          transition: Flip,
        });
      })
      .catch((err) => {
        console.error(err);
        toast.error("Failed to import CSV");
      })
      .finally(() => {
        setLoading(false);
        if (inputRef.current) inputRef.current.value = "";
      });
  };

  return { inputRef, handleImport };
};

export default useImport;
